import {motion} from 'framer-motion';
import {DropdownTag, Flag, Tooltip} from 'platform/components';

import {suffixTestId, TestIdProps} from 'shared/web';

import type {EntityHeaderDropdownFlag, EntityHeaderFlag} from '../EntityHeader';
import {SkeletonLoadingBox} from './SkeletonLoadingBox';

export interface SkeletonLoadingListProps extends TestIdProps {
  flags: EntityHeaderFlag[] | undefined;
  dropdownFlags: EntityHeaderDropdownFlag[] | undefined;
  isLoading?: boolean;
}

export function EntityHeaderFlags(props: SkeletonLoadingListProps) {
  return (
    <>
      {props.flags?.map((flag: EntityHeaderFlag, index) => (
        <motion.div key={`${flag.label}-${flag.colorScheme}`} layout="position">
          <SkeletonLoadingBox
            isLoading={props.isLoading}
            width={22}
            height={6}
            borderRadius="small"
          >
            <Tooltip
              {...flag.tooltip}
              data-testid={suffixTestId(`entityHeader-flags-tooltip-[${index}]`, props)}
            >
              <Flag
                {...flag}
                data-testid={suffixTestId(`entityHeader-flags-flag-[${index}]`, props)}
              />
            </Tooltip>
          </SkeletonLoadingBox>
        </motion.div>
      ))}
      {props.dropdownFlags?.map((flag, index) => (
        <motion.div key={`${flag.label}-${flag.colorScheme}`} layout="position">
          <SkeletonLoadingBox
            isLoading={props.isLoading}
            width={22}
            height={6}
            borderRadius="small"
          >
            <Tooltip
              {...flag.tooltip}
              data-testid={suffixTestId(`entityHeader-dropdownFlags-tooltip-[${index}]`, props)}
            >
              <DropdownTag
                {...flag}
                size="default"
                data-testid={suffixTestId(`entityHeader-dropdownFlags-flag-[${index}]`, props)}
              />
            </Tooltip>
          </SkeletonLoadingBox>
        </motion.div>
      ))}
    </>
  );
}
